
// Function to read the consent status and log the result
function checkNonNecessaryConsent() {
    if (!window.Cookiebot || !window.Cookiebot.consent) {

        return false;
    }
    // 1. Get the consent state from the Cookiebot global object
    var consent = window.Cookiebot.consent;

    // 2. Check the non-necessary categories
    var preferencesAccepted = consent.preferences;
    var statisticsAccepted = consent.statistics;
    var marketingAccepted = consent.marketing;

    // 3. Determine if ANY non-necessary category was accepted
    if (preferencesAccepted || statisticsAccepted || marketingAccepted) {
        // Return TRUE if any non-necessary category is accepted
        return true;

    } else {
        // console.log("Cookie Consent Status: ONLY NECESSARY COOKIES ACCEPTED/DEFAULT.");
        // Return FALSE if only necessary cookies were accepted (or no consent given)
        return false;
    }
}

// Ensure the code runs *after* Cookiebot has set the consent state.
window.addEventListener('CookiebotOnLoad', checkNonNecessaryConsent);
window.addEventListener('CookiebotOnAccept', checkNonNecessaryConsent);
window.addEventListener('CookiebotOnDecline', checkNonNecessaryConsent);
window.addEventListener('CookiebotOnRevoke', checkNonNecessaryConsent);
